import session from "../src/api/session";

// Action value is integer option with create=1 ,update=2, delete=3
export function eventCreate(msg, action) {
  session.post("api/event/create/", {
    action: action,
    notes: msg,
  });
}
